import React from 'react';

import { useTranslation } from 'react-i18next';

import './Modal.css';

const Modal = ({ content, onClose, buttons }) => {
    const { t } = useTranslation('portal');
    if (content.length === 0) return null;

    const defaultButton = <button className={'purple_button'} onClick={onClose}>{t('close')}</button>;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                {content[content.length - 1]}
                <div className="modal-buttons">
                    {buttons[buttons.length - 1] ? buttons[buttons.length - 1].map((btn, index) => React.cloneElement(btn, { key: index })) : defaultButton}
                </div>
            </div>
        </div>
    );
};

export default Modal;
